import styled from "styled-components";

export const CrossIconWrapper = styled.div`
    display: flex;
    align-items: center;
`